import Vue from 'vue';
import { format as dateFormat } from 'date-fns'

export const rawDateTime = (value, format = "dd'/'MM'/'yyyy HH':'mm") => {
  if (!value) return ''

  if (typeof value === 'string' && /^\d+$/.test(value)) {
    value = Number(value);
  }

  return dateFormat(new Date(value), format);
}

Vue.filter('dateTime', (value, format = "dd'/'MM'/'yyyy HH':'mm") => rawDateTime(value, format));
